import {Popover} from "@mui/material";
import Box from "@mui/material/Box";
import FilterFormForMultipleColumns from "./FilterFormForMultipleColumns";
import FilterFormForColumn from "./FilterFormForColumn";
import React from "react";
import {FilterValue, TableColumnsWithFilter} from "./_interfaces";

interface IFilterPopoverProps {
    columns: TableColumnsWithFilter[];
    globalFilterAnchorEl: HTMLElement | null;
    handleCloseGlobalFilter: () => void;
    filterAnchorEl: HTMLElement | null;
    isFilterOpen: boolean;
    handleCloseFilter: () => void;
    activeFilterColumn: any;
    filterValues: any;
    handleFilterChange: (filterType: string, columnId: string, value: FilterValue) => void;
    handleCancelGlobalFilters: () => void;
    handleApplyFilters: () => void;
    handleResetFilters: () => void;
    activeColumnIds: string[];
    handleActiveColumnIdsChange: (ids: string[]) => void;
    filterOptions: any;
}

const filterPopoverSx = {
    "& .MuiBackdrop-root" : {
        backgroundImage: "none",
        backgroundColor: "transparent",
    },
    "& .MuiPaper-root": {
        width: {xs: "calc(100% - 32px)", sm: 460, md: 510},
        backgroundColor: "info.light",
        backgroundImage: "none",
        overflow: "visible",
        padding: {xs: 0, sm: 1},
        borderRadius: 2,
        boxShadow: "0px 1px 6px rgba(0, 0, 0, 0.1)",
    },
};

const FilterPopover = ({
                           columns,
                           globalFilterAnchorEl,
                           handleCloseGlobalFilter,
                           filterAnchorEl,
                           isFilterOpen,
                           handleCloseFilter,
                           activeFilterColumn,
                           filterValues,
                           handleFilterChange,
                           handleCancelGlobalFilters,
                           handleApplyFilters,
                           handleResetFilters,
                           activeColumnIds,
                           handleActiveColumnIdsChange,
                           filterOptions
                       }: IFilterPopoverProps) => {
    return (
        <>
            <Popover
                open={Boolean(globalFilterAnchorEl)}
                anchorEl={globalFilterAnchorEl}
                onClose={handleCloseGlobalFilter}
                anchorOrigin={{vertical: "bottom", horizontal: "right"}}
                transformOrigin={{vertical: "top", horizontal: "right"}}
                sx={filterPopoverSx}
            >
                <Box sx={{minWidth: "100%"}}>
                    <FilterFormForMultipleColumns
                        columns={columns}
                        values={filterValues}
                        onChange={handleFilterChange}
                        onCancel={handleCancelGlobalFilters}
                        onApply={handleApplyFilters}
                        resetFormData={handleResetFilters}
                        activeColumnIds={activeColumnIds}
                        onActiveColumnIdsChange={handleActiveColumnIdsChange}
                        filterOptions={filterOptions}
                    />
                </Box>
            </Popover>

            <Popover
                open={isFilterOpen}
                anchorEl={filterAnchorEl}
                onClose={handleCloseFilter}
                anchorOrigin={{vertical: "bottom", horizontal: "center"}}
                transformOrigin={{vertical: "top", horizontal: "center"}}
                sx={filterPopoverSx}
            >
                <Box sx={{minWidth: "100%"}}>
                    {activeFilterColumn && (
                        <FilterFormForColumn
                            column={activeFilterColumn}
                            values={filterValues}
                            onChange={handleFilterChange}
                            onCancel={handleCloseFilter}
                            onApply={handleApplyFilters}
                            activeColumnIds={activeColumnIds}
                            onActiveColumnIdsChange={handleActiveColumnIdsChange}
                            filterOptions={filterOptions}
                        />
                    )}
                </Box>
            </Popover>
        </>
    )
}
export default FilterPopover;